<form [formGroup]="form">
  <div>
    <span><b>Empresa</b></span>
    <div class="grid grid-cols-3 gap-3 mt-3">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Nome Fantasia</mat-label>
        <input matInput type="text" formControlName="tradeName" />
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Razão Social</mat-label>
        <input matInput type="text" formControlName="companyName" />
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>CNPJ</mat-label>
        <input matInput type="text" formControlName="document" mask="AA.AAA.AAA/0000-00" />
      </mat-form-field>
    </div>
    <div class="grid grid-cols-3 gap-3 mt-3 items-center">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Incrição Estadual</mat-label>
        <input matInput type="text" formControlName="stateRegistration" />
      </mat-form-field>
      <div>
        <mat-checkbox formControlName="hasStateRegistrationExemption">
          <span>Isento Inscrição Estadual</span>
        </mat-checkbox>
        <br />
      </div>
    </div>
  </div>

  <div class="mt-3" formGroupName="address">
    <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
      <span><b>Endereço</b></span>
      <div class="grid grid-cols-4 gap-3 mt-3">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>CEP</mat-label>
          <input matInput type="text" formControlName="zipCode" mask="00000-000" />
        </mat-form-field>

        <app-select-form-field label="Estado" [control]="state" [options]="states" [display]="stateDisplayName" />
        <app-select-form-field label="Cidade" [control]="city" [options]="cities" />

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Bairro</mat-label>
          <input matInput type="text" formControlName="neighborhood" />
        </mat-form-field>
      </div>
      <div class="grid grid-cols-3 gap-3 mt-3">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Endereço</mat-label>
          <input matInput type="text" formControlName="streetName" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Complemento</mat-label>
          <input matInput type="text" formControlName="complement" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Contatos</mat-label>
          <textarea matInput micScrollBar rows="1" formControlName="phone"></textarea>
        </mat-form-field>
      </div>
    </mic-spinner-overlay>
  </div>
</form>
